import { apiClient } from "./apiClient";
import { UserPreferenceDto, UserPreferenceUpdateRequest } from "../models/UserPreferenceModel";

/**
 * Get current user's preferences
 */
export const getPreferences = async (): Promise<UserPreferenceDto> => {
  return apiClient.get<UserPreferenceDto>("/api/users/me/preferences");
};

/**
 * Update current user's preferences
 * Only provided fields will be updated (partial update)
 */
export const updatePreferences = async (
  request: UserPreferenceUpdateRequest
): Promise<UserPreferenceDto> => {
  return apiClient.put<UserPreferenceDto>("/api/users/me/preferences", request);
};